module.exports = __webpack_public_path__ + "static/media/credit-icon.6267c138.svg";